// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2H0ZZ","rootNoMargin":"styles_rootNoMargin__79nfD"};